// extracted by mini-css-extract-plugin
module.exports = {"item":"TopicFilter_item__0dk_V","tag":"TopicFilter_tag__rC18U"};